<template>
  <div>
    <div class="message is-info">
      <div class="message-body has-text-dark">
        <p class="is-size-4">
          {{ $t('domains.dns.heading') }}
        </p>
      </div>
    </div>

    <div class="form-section">
      <custom-input
        v-model="email"
        stop-clearfix
        :style="{width: '100%'}"
        label="Email"
        :input-class="`input ${hasErrorClass($v.email)}`"
        :error-text="errorGenerator($v.email)"
        @input="delayTouch($v.email)"
      />
      <custom-input
        v-model="description"
        type="textarea"
        stop-clearfix
        :style="{width: '100%'}"
        label="Description"
        :input-class="`input ${hasErrorClass($v.description)}`"
        :error-text="errorGenerator($v.description)"
        @input="delayTouch($v.description)"
      />
    </div>
    <div class="form-section table-foot">
      <button
        class="button is-primary is-broad is-large is-uppercase"
        @click.prevent="handleCancel($v)"
      >
        {{ $t('common.cancel') }}
      </button>
      <button
        class="button is-primary is-broad is-large is-uppercase"
        @click.prevent="handleSubmit($v)"
      >
        {{ $t('common.submit') }}
      </button>
    </div>
  </div>
</template>

<script>
import CustomInput from '@/components/Shared/CustomInput'
import { required, email } from 'vuelidate/lib/validators'
import formHelperMixin from '@/mixins/form-helper'
export default {

  name: 'DNSSecurity',
  components: {
    CustomInput
  },
  mixins: [formHelperMixin],
  validations () {
    return {
      description: {
        required
      },
      email: {
        required,
        email
      }
    }
  },
  data () {
    return {
      email: '',
      description: ''
    }
  },
  methods: {
    handleSubmit () {

    }
  }
}
</script>

<style lang="css" scoped>
  .form-section {
    background-color: var(--form-color-light);
  }
  .table-foot {
    align-items: flex-end;
    display: flex;
    justify-content: space-between;
  }
</style>
